
import { Component, toNative, Vue } from 'vue-facing-decorator';
import { VueDraggableNext } from 'vue-draggable-next';
import SideDrawer from '@/components/Common/SideDrawer.vue';
import ModalPopup from '@/components/Common/ModalPopup.vue';
import ParticipantExtraInformation from '@/entities/Participants/ParticipantExtraInformation';
import MyInformationSourceEnum from '@/enums/MyInformationSourceEnum';
import { FetchData } from '@/main';

@Component({
  components: { draggable: VueDraggableNext, SideDrawer, ModalPopup },
})
class MyInformationView extends Vue {
  private addIcon = require('@/assets/Images/white-add-icon.svg');
  private exportIcon = require('@/assets/Images/export-icon.svg');
  private deletePopupIcon = require('@/assets/Images/Delete-popup-icon.svg');
  private openMenuId: number | null = null;
  private dropdownAbove = false;
  // ── Drawer state ────────────────────────────────────────────────────────
  private showAddDrawer = false;
  private showEditDrawer = false;
  private drawerFieldName = '';
  private drawerHideFromApp = false;
  private editingFieldId: number | null = null;
  private myInformationListData: ParticipantExtraInformation[] = [];

  // ── Delete modal state ─────────────────────────────────────────────────
  private showModalPopup = false;
  private modalPopupHeading = '';
  private modalPopupBodyHeading = '';
  private modalPopupBodyContent = '';
  private modalPopupShowCancelButton = false;
  private modalPopupCancelButtonText = '';
  private modalPopupConfirmButtonText = '';
  private showCloseButton = false;
  private pendingDeleteFieldId: number | null = null;

  private mounted() {
    this.GetMyinformationList();
    document.addEventListener('click', this.CloseAllMenus);
  }

  // Fetch MyInformation list data
  private GetMyinformationList(){
    FetchData('/EventAttendee/GetEventMyInformation','').then((response)=>{
      this.myInformationListData = response;
    }).catch(()=>{
      // console error if any
    });
  }

  private beforeUnmount() {
    document.removeEventListener('click', this.CloseAllMenus);
  }

  private CloseAllMenus() {
    this.openMenuId = null;
  }

  private OnToggleVisible(item: ParticipantExtraInformation) {
    item.IsVisibleInApp = !item.IsVisibleInApp;
    // TODO: FetchData('/MyInformation/UpdateVisibility', JSON.stringify({ id: item.Id, isVisibleInApp: item.IsVisibleInApp }))
  }

  private ToggleFieldMenu(id: number, event: MouseEvent) {
    if (this.openMenuId === id) {
      this.openMenuId = null;
      return;
    }
    const btn = event.currentTarget as HTMLElement;
    const rect = btn.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    // If less than 100px of space below the button, open the menu above
    this.dropdownAbove = spaceBelow < 100;
    this.openMenuId = id;
  }

  private OnDragEnd() {
    // Update SortOrder based on new array positions
    this.myInformationListData.forEach((f, i) => {
      f.SortOrder = i + 1;
    });
    // TODO: FetchData('/MyInformation/UpdateSortOrder', JSON.stringify(this.fields.map((f) => ({ id: f.Id, sortOrder: f.SortOrder }))))
  }

  // ── Drawer: Add field ───────────────────────────────────────────────────
  private OpenAddDrawer() {
    this.drawerFieldName = '';
    this.drawerHideFromApp = false;
    this.showAddDrawer = true;
  }

  private ConfirmAdd() {
    const maxId = this.myInformationListData.reduce((max, f) => Math.max(max, f.Id), 0);
    const newField = new ParticipantExtraInformation(
      maxId + 1,
      0,
      0,
      '',
      this.drawerFieldName.trim(),
      0,
      this.myInformationListData.length + 1,
      MyInformationSourceEnum.ManuallyCreated,
      !this.drawerHideFromApp,
      0,
      false,
    );
    this.myInformationListData.push(newField);
    this.showAddDrawer = false;
  }

  // ── Drawer: Edit field ──────────────────────────────────────────────────
  private OpenEditDrawer(field: ParticipantExtraInformation) {
    this.editingFieldId = field.Id;
    this.drawerFieldName = field.KeyValue;
    this.drawerHideFromApp = !field.IsVisibleInApp;
    this.openMenuId = null;
    this.showEditDrawer = true;
  }

  private ConfirmEdit() {
    const field = this.myInformationListData.find((f) => f.Id === this.editingFieldId);
    if (field) {
      field.KeyValue = this.drawerFieldName.trim();
      field.IsVisibleInApp = !this.drawerHideFromApp;
    }
    this.showEditDrawer = false;
    // TODO: FetchData('/MyInformation/UpdateField', JSON.stringify({ id: this.editingFieldId, field: this.drawerFieldName, isVisibleInApp: !this.drawerHideFromApp }))
  }

  // ── Delete modal ───────────────────────────────────────────────────────
  private ShowDeletePopup(field: ParticipantExtraInformation) {
    this.openMenuId = null;
    const isManual = field.Source.toLowerCase() === MyInformationSourceEnum.ManuallyCreated.toLowerCase();
    this.pendingDeleteFieldId = isManual ? field.Id : null;
    this.modalPopupHeading = this.$t('MyInformation.DeleteTitle').toString();
    this.modalPopupBodyHeading = '';
    this.modalPopupBodyContent = isManual
      ? this.$t('MyInformation.DeleteBody').toString()
      : this.$t('MyInformation.DeleteNotAllowed').toString();
    this.modalPopupShowCancelButton = isManual;
    this.modalPopupCancelButtonText = this.$t('CancelButton').toString();
    this.modalPopupConfirmButtonText = isManual
      ? this.$t('Button.Delete').toString()
      : this.$t('Button.Ok').toString();
    this.showCloseButton = true;
    this.showModalPopup = true;
  }

  private ConfirmClick(confirmed: boolean) {
    this.showModalPopup = false;
    if (confirmed && this.pendingDeleteFieldId !== null) {
      this.DeleteField(this.pendingDeleteFieldId);
    }
    this.pendingDeleteFieldId = null;
  }

  private DeleteField(fieldId: number) {
    // FetchData('/Participant/DeleteParticipantExtraInformation', JSON.stringify({ extraInformationId: fieldId }))
    //   .then(() => {
    this.myInformationListData = this.myInformationListData.filter((f) => f.Id !== fieldId);
    // });
  }
}

export default toNative(MyInformationView);
